import React, { useEffect } from "react";

const GoTo = () => {
  useEffect(() => {
    const progressWrap = document.querySelector(".progress-wrap");
    if (!progressWrap) return;
    const progressPath = progressWrap.querySelector("path");
    if (!progressPath) return;
    const pathLength = progressPath.getTotalLength();

    progressPath.style.transition = "none";
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;

    progressPath.getBoundingClientRect();

    progressPath.style.transition = "stroke-dashoffset 10ms linear";

    const updateProgress = () => {
      const scroll = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = pathLength - (scroll * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress);

    const offset = 200;
    const duration = 0;

    const handleScroll = () => {
      const progressWrap = document.querySelector(".progress-wrap");
      if (!progressWrap) return;
      
      if (window.scrollY > offset) {
        progressWrap.classList.add("active-progress");
      } else {
        progressWrap.classList.remove("active-progress");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const handleClick = (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    progressWrap.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("scroll", handleScroll);
      if (progressWrap) {
        progressWrap.removeEventListener("click", handleClick);
      }
    };
  }, []);

  return (
    <div className="progress-wrap">
      <svg
        className="progress-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            transition: "stroke-dashoffset 10ms linear 0s",
            strokeDasharray: "307.919, 307.919",
            strokeDashoffset: "286.138",
          }}
        ></path>
      </svg>
    </div>
  );
};

export default GoTo;
